import React from 'react';
import PropTypes from 'prop-types';
import MaterialRadioGroup from '@material-ui/core/RadioGroup';
import MaterialRadio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useFormContext } from '../Form';
import useRegisterInput from '../Form/useRegisterInput';

const RadioGroup = ({ name, onChange, options, register: shouldRegister, value }) => {
  useRegisterInput(name, shouldRegister);

  const formContext = useFormContext();
  const { setValue, watch } = formContext ?? {};
  const inputValue = value ?? (watch && watch(name));

  /**
   * Handle the change on the select.
   * @param {object|Event} ev
   */
  const handleOnChange = ev => {
    if (formContext && !onChange) {
      setValue(name, ev.target.value);
      return;
    }

    if (onChange) {
      onChange(ev, ev.target.value);
    }
  };

  return (
    <MaterialRadioGroup name={name} onChange={handleOnChange} value={inputValue}>
      {options.map(option => (
        <FormControlLabel
          value={option?.value}
          key={option?.value}
          control={<MaterialRadio />}
          label={option?.label}
        />
      ))}
    </MaterialRadioGroup>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array,
  register: PropTypes.bool,
  value: PropTypes.any,
};

RadioGroup.defaultProps = {
  onChange: undefined,
  options: [],
  register: true,
  value: undefined,
};

export default RadioGroup;
